
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Projekte',
    showminies:true,
    showmedia:false,
    vuexnamespace: 'projects',
    initmutation:'projects/PROJECT_INIT_PROJECT',
    backlink:'projects',
    duplicateable:false,
    helptext:"Die Projektdaten werden in diesem Formular erfasst. <br> <br>\n\
            Nach Eingabe der Stammdaten öffnet sich im unteren Teil des Formulars die \n\
            Tabelle für die zum Projekt gehörigen Rezepte. Dieser Tabelle können Rezepte \n\
            mittels des Plus-Symbols hinzugefügt werden. Einzelne Zeilen werden mit dem kleinen \n\
            Mülleimer-Symbol gelöscht. <br><br>\n\
            Gespeichert wird das Projekt wie gewohnt mit dem goldenen Haken. Mit dem schwarzen Kreuz verläßt \n\
            man das Formular zurück zur Projektübersicht."                                                       
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};